import React from 'react';
import './Instructions.css';

const Instructions = () => {
  const items = [
    {
      title: 'Android / iOS',
      description: 'Скачайте приложение и отсканируйте QR-код или вставьте ссылку на подписку.',
      link: '#',
    },
    {
      title: 'Android TV',
      description: 'Используйте Happ (рекомендуем) или v2RayTun.',
      links: [{ label: 'Happ ↗', href: '#' }, { label: 'v2RayTun ↗', href: '#' }],
    },
    {
      title: 'Windows / macOS / Linux',
      description: 'Скачайте клиент для ПК и импортируйте подписку.',
      link: '#',
    },
    {
      title: 'Обновить подписку',
      description: 'Как обновить подписку в приложении после продления.',
      link: '#',
    },
  ];

  return (
    <div className="instructions-grid">
      {items.map((item, idx) => (
        <div key={idx} className="instruction-card">
          <div className="instruction-title">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#4aae88" strokeWidth="1.7">
              <path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H12v16H6.5A2.5 2.5 0 0 0 4 21.5z" />
              <path d="M20 5.5A2.5 2.5 0 0 0 17.5 3H12v16h5.5a2.5 2.5 0 0 1 2.5 2.5z" />
            </svg>
            {item.title}
          </div>
          <p className="instruction-desc">{item.description}</p>
          {item.link && <a href={item.link} className="instruction-link">Открыть инструкцию ↗</a>}
          {item.links && (
            <div className="instruction-links">
              {item.links.map((l, i) => <a key={i} href={l.href}>{l.label}</a>)}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Instructions;